import React from 'react';

const AppLinks = ({ className = "" }) => {
    return (
        <div className={`header-download-buttons ${className}`}>
            <a className="download-button me-3" href="https://play.google.com/store/apps/details?id=com.toytrade.exchange&referrer=utm_source%3Dwebsite%26">
                <img src="/images/download_google.svg" alt="Download on Google Play" />
            </a>
            <a className="download-button" href="https://apps.apple.com/pk/app/toy-trade-pakistan/id6742099837?source=website">
                <img src="/images/download_appstore.svg" alt="Download on the App Store" />
            </a>
        </div>
    );
};

export default AppLinks;
